"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTime = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../lib/utils");
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        time: {
            fontSize: 12,
        },
    });
});
var MediaTime = function (props) {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.time }, utils_1.timeToString(props.time)));
};
exports.MediaTime = MediaTime;
//# sourceMappingURL=MediaTime.js.map